import React from 'react';
import {Grid, Header} from 'semantic-ui-react';
import PositionPayment from 'go/components/modules/requestDetails/v3/items/paymentRequest/staffingBundled/PositionPayment';
import {Alert} from 'componentLibrary';
import {PAYMENT_PATH_ROOT} from 'common/requestDetails/constants.js';
import {
  calculateFederalTotal,
  getValidPositions,
} from 'common/requestDetails/utils';
import {showDollarAmountWithDollar} from 'common/utils';
import _ from 'lodash';

export const StaffingBundledPayment = (props) => {
  const positionsFromRoster = _.cloneDeep(props.roster);
  const {
    item,
    fundingOpportunityStreams,
    staffingStreamType,
    periodOfPerformance,
    paymentPeriod,
    approvedPayments,
    grantBudgetShareFedRate,
    editable,
    totalsInfo,
    validationErrors,
    validationDirtyMap,
    turnOffvalidationLimits,
    tier,
    itemConfig
  } = props;

  const startDate = _.get(paymentPeriod, 'startDate');
  const endDate = _.get(paymentPeriod, 'endDate');

  const positionsWithInvalidEmployeesFlagged = getValidPositions(
    positionsFromRoster,
    startDate,
    endDate
  );

  const showDiscrepancyAlert =
    _.get(totalsInfo, 'fedResourcesRequestedRounded', 0) !==
    _.get(totalsInfo, 'fedResourcesRequestedUnrounded', 0);

  if (_.isEmpty(_.get(item, 'additionalInformation.payment'))) {
    let payment = [];

    _.forEach(positionsWithInvalidEmployeesFlagged, (pos, posIndex) => {
      const invalidObject = {
        valid: false,
        positionId: pos.positionId,
      };

      if (_.isEmpty(pos.employees)) {
        payment.push(invalidObject);
        return;
      }

      let employees = {};

      _.forEach(pos.employees, (employee) => {
        if (employee.duringPaymentPeriod) {
          _.set(employees, employee.rosterId, {
            valid: true,
            positionId: pos.positionId,
          });
        }
      });

      if (_.isEmpty(employees)) {
        payment.push(invalidObject);
      } else {
        payment.push({
          valid: true,
          positionId: pos.positionId,
          employees,
        });
      }
    });

    const clonedItem = _.cloneDeep(item);
    _.set(clonedItem, 'additionalInformation.payment', payment);
    props.handleChange(clonedItem).then((res) => props.handleBlur());
  } else {
    let employeesToClean = {};
    let employeesToAdd = {};

    _.forEach(positionsWithInvalidEmployeesFlagged, (pos, posIndex) => {
      _.forEach(pos.employees, (employee, posKey) => {
        let employeePayment = _.get(item, [
          ...PAYMENT_PATH_ROOT,
          posIndex,
          'employees',
          _.get(employee, 'rosterId'),
        ]);
        if (!employee.duringPaymentPeriod && !_.isEmpty(employeePayment)) {
          _.set(employeesToClean, pos.positionId, {
            rosterId: employee.rosterId,
          });
        } else if (
          employee.duringPaymentPeriod &&
          _.isEmpty(
            _.get(item, [
              ...PAYMENT_PATH_ROOT,
              employee.positionId,
              'employees',
              _.get(employee, ['rosterId']),
            ])
          )
        ) {
          _.set(employeesToAdd, pos.positionId, {
            rosterId: employee.rosterId,
          });
        }
      });
    });
    if (!_.isEmpty(employeesToClean) || !_.isEmpty(employeesToAdd)) {
      const clonedPayment = _.cloneDeep(item);
      _.each(_.keys(employeesToClean), (key) => {
        _.set(clonedPayment, [...PAYMENT_PATH_ROOT, key], {
          positionId: _.toInteger(key),
          valid: false,
        });
      });

      _.each(_.keys(employeesToAdd), (key) => {
        _.set(
          clonedPayment,
          [
            ...PAYMENT_PATH_ROOT,
            key,
            'employees',
            _.get(employeesToAdd, [key, 'rosterId']),
          ],
          {
            positionId: _.toInteger(key),
            valid: false,
          }
        );
      });
      if(!_.isEqual(item, clonedPayment)) {
        props.handleChange(clonedPayment).then((res) => props.handleBlur());
      }
    }
  }

  const itemPayment = _.get(item, 'additionalInformation.payment');

  return (
    <React.Fragment>
      {_.map(itemPayment, (positionPayment, ind) => {
        if (_.isEmpty(positionPayment)) return null;

        const {positionId} = positionPayment;
        const pos = _.find(
          positionsWithInvalidEmployeesFlagged,
          (pos) => pos.positionId == positionId || pos.positionId == ind
        );

        const positionDisplayId = pos.positionDisplayId;

        if (_.isEmpty(pos.employees)) {
          return null;
        }

        return (
          <PositionPayment
            key={_.toNumber(positionId)}
            positionId={_.toNumber(positionId)}
            positionDisplayId={positionDisplayId}
            item={item}
            editable={editable}
            fundingOpportunityStreams={fundingOpportunityStreams}
            staffingStreamType={staffingStreamType}
            periodOfPerformance={periodOfPerformance}
            paymentPeriod={paymentPeriod}
            approvedPositionPayments={_.map(approvedPayments, (payment) => {
              return _.get(payment, positionId);
            })}
            grantBudgetShareFedRate={grantBudgetShareFedRate}
            employees={pos.employees}
            validationErrors={validationErrors}
            validationDirtyMap={validationDirtyMap}
            handleChange={(paymentSection) => {
              const toChange = _.cloneDeep(item);
              _.set(toChange, [...PAYMENT_PATH_ROOT, positionId], paymentSection);
              return props.handleChange(toChange);
            }}
            handleBlur={(fieldName) => {
              return props.handleBlur(_.join([...PAYMENT_PATH_ROOT, positionId, fieldName], '.'))}
            }
            turnOffvalidationLimits={turnOffvalidationLimits}
            tier={tier}
            itemConfig={itemConfig}
          />
        );
      })}
    </React.Fragment>
  );
};

export default StaffingBundledPayment;
